<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view name='head'/>
    <router-view name='content'/>
    <router-view name='foot'/>
  </div>
</template>

<script>
export default {
  name: 'App',
  
}

</script>

<style>
  #app{
    width: 100%;
  }
  @media screen and (max-width: 640px) {
    #app{
      padding-bottom: 100px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/App.vue